










































































import {
  Component,
  Prop,
  Vue
} from "@/shared/vuepack";
import {
  HsabExpenseCategory,
  HsabExpenseReimbursementResponse,
  HsabExpenseResponse,
  HsabSsoDestination,
} from "@/shared/types";
import Button from "@/shared/components/ui/Button.vue";
import HsabExpenseCardRowExpenseDetail from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseCardRowExpenseDetail.vue";
import HsabExpenseCardRowPayee from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseCardRowPayee.vue";
import HsabExpenseCardRowExpenseEvidence from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseCardRowExpenseEvidence.vue";
import HsabExpenseCardRowDenial from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseCardRowDenial.vue";
import SsoDeepLink from "@/shared/components/ui/SsoDeepLink.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import HsabExpenseCardRowPaymentDetail from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseCardRowPaymentDetail.vue";
import HsabExpenseCardRowRepayments from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseCardRowRepayments.vue";
import { useThemeStore } from "@/shared/store/theme";
import { useHsabExpenseStore } from "@/employee/store/hsabExpense";
import { useHsabExpenseEvidenceStore } from "@/employee/store/hsabExpenseEvidence";

@Component({
  computed: {
    HsabSsoDestination () {
      return HsabSsoDestination;
    }
  },
  components: {
    HsabExpenseCardRowRepayments,
    HsabExpenseCardRowPaymentDetail,
    GenericLoadingSpinner,
    SsoDeepLink,
    HsabExpenseCardRowDenial,
    HsabExpenseCardRowExpenseEvidence,
    HsabExpenseCardRowPayee,
    HsabExpenseCardRowExpenseDetail,
    Button
  }
})
export default class HsbExpenseCardRowExpanded extends Vue {

  themeStore = useThemeStore();
  hsabExpenseStore = useHsabExpenseStore();
  hsabExpenseEvidenceStore = useHsabExpenseEvidenceStore();

  @Prop({ required: true })
  expense: HsabExpenseResponse;
  isAddingAdditionalEvidence = false;
  isUploadingFilesToSubmittedExpense = false;
  stagedFilesForUpload = [];

  get expenseCategory (): HsabExpenseCategory {
    return this.expense.expenseCategory;
  }

  get reimbursement (): HsabExpenseReimbursementResponse {
    return this.expense.reimbursement;
  }
  get showDenialReasons (): boolean {
    const hasReimbursement = this.expense && this.expense.reimbursement;
    const hasDenialReasons = hasReimbursement
        && this.expense.reimbursement.denialReasons
        && this.expense.reimbursement.denialReasons.length > 0;
    const hasDeniedAmount = this.expense.reimbursement.deniedAmount > 0;

    return hasReimbursement && (hasDenialReasons || hasDeniedAmount);
  }

  get showRepayments (): boolean {
    return this.expense
        && this.expense.reimbursement
        && this.expense.reimbursement.repayments
        && this.expense.reimbursement.repayments.length > 0;
  }

  get showRepayButton (): boolean {
    return this.showRepayments
        && this.expense.reimbursement.repayments.filter(x => x.outstandingAmount > 0).length > 0;
  }

  handleClose () {
    this.$emit("close-action");
  }

  handleAddedFiles (files) {
    this.isAddingAdditionalEvidence = true;
    this.stagedFilesForUpload = files;
  }
  handleAddFilesAfterSubmitted () {
    if (!this.expense || !this.stagedFilesForUpload) {
      return;
    }

    this.isUploadingFilesToSubmittedExpense = true;
    this.hsabExpenseEvidenceStore.UploadFilesToSubmittedHsabExpense(
            this.expense.hsabExpenseId,
            this.stagedFilesForUpload,
            this.expense.reimbursement.isHsaReimbursement)
        .then(_ => {
          this.isUploadingFilesToSubmittedExpense = false;
          this.hsabExpenseStore.loadPageSubmittedExpenses({
            page: this.hsabExpenseStore.submittedExpenses.page,
            force: true
          });
          this.handleClose();
        })
        .catch(err => {
          this.isUploadingFilesToSubmittedExpense = false;
        });
  }

}
